/**
 * logService — Logger centralizado do frontend TechCambio
 *
 * Em desenvolvimento: exibe no console normalmente.
 * Em produção: info/warn são silenciosos; error envia para o Sentry.
 *
 * Uso:
 *   import logService from '@/services/logService';
 *   logService.info('Socket conectado', { userId });
 *   logService.warn('Config não encontrada, usando fallback');
 *   logService.error('Não foi possível processar callback', error);
 */

import * as Sentry from '@sentry/vue';

const isDev = import.meta.env.DEV;

const logService = {
  info(...args) {
    if (isDev) console.info(...args); // eslint-disable-line no-console
  },

  warn(...args) {
    if (isDev) console.warn(...args); // eslint-disable-line no-console
  },

  error(message, error = null) {
    if (isDev) console.error(message, error); // eslint-disable-line no-console

    if (error instanceof Error) {
      Sentry.captureException(error, { extra: { message } });

      return;
    }

    Sentry.captureMessage(String(message), 'error');
  }
};

export default logService;
